import React, { FC, useEffect, useState } from 'react';
import { SCUIButton, SCUITabs, SCUINoRecordComponent, SCUILoadingLinear } from '../../../atomic/atoms';
import { SCUIContent } from '../../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIOFSDrawerContent, SCUIOFSAddToListModal } from './components';
import {
    SCUIGeneralDrawer,
    SCUICustomDataGrid,
    SCUIBreadCrumb,
    SCUITextFieldWithSelectBox,
} from '../../../atomic/molecules';
import { OFSLogsCommand } from '../../../services/command';
import { Box, Grid } from '@mui/material';
import TimeHelper from '../../../utils/time';
import { initialState } from './OFSLog.helper';
import { enumECommerceMessageType, enumOfsCenterMessageType } from '../../../types/enums/status';

export const OFSLogs: FC<any> = () => {
    const [searchedText, setSearchedText] = useState('');
    const [ofsInformationInput, setOfsInformationInput] = useState(initialState.filterInfo);
    const { t } = useTranslation();
    const [listModalOpen, setListModalOpen] = useState(false);
    const [ofsLog, setOFSLog] = useState<any>();
    const [datas, setDatas] = React.useState<any>();
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const handleCloseModal = () => {
        setListModalOpen(false);
    };
    const handleShowOFSLog = (item: any) => {
        setOFSLog(item);
        onDrawerOpen();
    };
    const [tabIndex, setTabIndex] = useState<any>(1);
    const [documentType, setDocumentType] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [pageNumber, setPageNumber] = React.useState(0);
    const [rowCount, setRowCount] = React.useState(0);
    const [loading, setLoading] = React.useState(false);

    const enumNotificationTabsIndexTabs = [
        { id: 1, name: 'OFC Center' },
        { id: 2, name: 'Ecommerce' },
    ];
    const _onChangeTabs = (event: any, activeTabIndex: any): void => {
        setTabIndex(activeTabIndex);
    };
    useEffect(() => {
        if (ofsInformationInput.referenceIdList.length > 0) {
            GetOFSInformation();
        }
    }, [ofsInformationInput]);

    const listele = async () => {
        if (searchedText.trim().length === 0) {
            Swal.fire({
                icon: 'error',
                title: t('general.emptyFieldControlText'),
                showConfirmButton: false,
                timer: 1500,
            });
        } else {
            let referenceIDList: any = [];
            searchedText
                .trim()
                .split('\n')
                .forEach((item: any) => {
                    if (item.trim().length > 0) {
                        referenceIDList.push(Number(item));
                    }
                });
            setPageNumber(0);

            let params = {
                isECommerceMessage: tabIndex === 1 ? false : true,
                referenceIdList: referenceIDList,
                eCommerceMessageType: tabIndex === 2 && documentType !== 0 ? documentType : null,
                ofsCenterMessageType: tabIndex === 1 && documentType !== 0 ? documentType : null,
                take: pageSize,
                skip: 0,
            };
            handleCloseModal();
            GetOFSInformation(params);
        }
    };

    const UpdateOFSInformation = async (row?: any) => {
        let params = {
            isECommerceMessage: tabIndex === 1 ? true : false,
            referenceIdList: row ? [row.referenceId] : ofsInformationInput.referenceIdList,
            eCommerceMessageType:
                row && row.eCommerceMessageType ? row.eCommerceMessageType : tabIndex === 1 ? documentType : null,
            ofsCenterMessageType:
                row && row.ofsCenterMessageType ? row.ofsCenterMessageType : tabIndex === 2 ? documentType : null,
        };
        OFSLogsCommand.PostUpdateOFSInformation(params).then((res: any) => {
            Swal.fire({
                icon: res.result ? 'success' : 'error',
                timer: 1500,
            });
        });
    };

    const GetOFSInformation = async (params?: any) => {
        setLoading(true);
        OFSLogsCommand.PostGetOFSInformation(params ?? ofsInformationInput)
            .then((res: any) => {
                if (!res?.data) {
                    Swal.fire({
                        icon: 'error',
                        title: t('general.error'),
                        text: t('general.recordNotFound'),
                        timer: 2000,
                    });
                    setDatas([]);
                    setRowCount(0);
                    return;
                }

                const ofsCenterMessages = res.data.ofsCenterMessages || [];
                const eCommerceMessages = res.data.eCommerceMessages || [];

                if (ofsCenterMessages.length > 0) {
                    setDatas(ofsCenterMessages);
                } else if (eCommerceMessages.length > 0) {
                    setDatas(eCommerceMessages);
                } else {
                    Swal.fire({
                        icon: 'info',
                        title: t('general.info'),
                        text: t('general.recordNotFound'),
                        timer: 2000,
                    });
                    setDatas([]);
                }
                setRowCount(res.count || 0);
            })
            .catch((error: any) => {
                console.error('Hata :>> ', error);
                Swal.fire({
                    icon: 'error',
                    title: t('general.error'),
                    text: t('general.recordNotFound'),
                    timer: 2000,
                });
                setDatas([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <SCUIContent>
            <SCUIOFSAddToListModal
                open={listModalOpen}
                onClose={handleCloseModal}
                searchedText={searchedText}
                setSearchedText={setSearchedText}
                listele={listele}
            />
            <SCUIGeneralDrawer
                open={drawerOpen}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerOpen(false);
                    }
                }}
            >
                <SCUIOFSDrawerContent ofsLog={ofsLog} onClose={onDrawerClose} />
            </SCUIGeneralDrawer>
            <Box className="ofs-logs">
                <Grid
                    className="ofs-logs-header"
                    container
                    direction="row"
                    spacing={2}
                    sx={{ marginLeft: '0.5rem', marginBottom: '16px' }}
                >
                    <SCUIBreadCrumb title={t('billings.ofsLogs')} componentLink={'ofsLogs'} />
                    <SCUILoadingLinear display={loading} />
                    <Grid
                        className="ofs-logs-tabs"
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUITabs
                            tabList={Object.values(enumNotificationTabsIndexTabs)}
                            onChange={_onChangeTabs}
                            activeTabIndex={tabIndex}
                        ></SCUITabs>
                    </Grid>

                    <Grid
                        className="ofs-logs-search-input"
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 6,
                            xl: 6,
                        }}
                    >
                        <SCUITextFieldWithSelectBox
                            placeholder={'referenceId'}
                            buttonText={t('general.search')}
                            selectList={tabIndex === 1 ? enumOfsCenterMessageType : enumECommerceMessageType}
                            onChangeSelect={(event: any) => {
                                setDocumentType(event.target.value);
                            }}
                            selectValue={documentType}
                            onChangeTextField={(event: any) => {
                                setSearchedText(event.target.value);
                            }}
                            onClickButton={() => {
                                setPageNumber(0);
                                let referenceIDList: any = [];
                                searchedText
                                    .trim()
                                    .split('\n')
                                    .forEach((item: any) => {
                                        if (item.trim().length > 0) {
                                            referenceIDList.push(Number(item));
                                        }
                                    });
                                setOfsInformationInput({
                                    isECommerceMessage: tabIndex === 1 ? false : true,
                                    referenceIdList: referenceIDList,
                                    eCommerceMessageType: tabIndex === 2 && documentType !== 0 ? documentType : null,
                                    ofsCenterMessageType: tabIndex === 1 && documentType !== 0 ? documentType : null,
                                    take: pageSize,
                                    skip: 0,
                                });
                            }}
                            onKeyPressTextField={(e: any) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    setPageNumber(0);
                                    let referenceIDList: any = [];
                                    searchedText
                                        .trim()
                                        .split('\n')
                                        .forEach((item: any) => {
                                            if (item.trim().length > 0) {
                                                referenceIDList.push(Number(item));
                                            }
                                        });
                                    setOfsInformationInput({
                                        isECommerceMessage: tabIndex === 1 ? false : true,
                                        referenceIdList: referenceIDList,
                                        eCommerceMessageType:
                                            tabIndex === 2 && documentType !== 0 ? documentType : null,
                                        ofsCenterMessageType:
                                            tabIndex === 1 && documentType !== 0 ? documentType : null,
                                        take: pageSize,
                                        skip: 0,
                                    });
                                }
                            }}
                        />
                    </Grid>
                    <Grid
                        className="ofs-logs-batch-search"
                        size={{
                            md: 6,
                            lg: 2,
                            xl: 2,
                        }}
                    >
                        <SCUIButton
                            className="ofs-logs-batch-search-button"
                            text={t('general.batchSearch')}
                            type="secondary"
                            sizeType="fixed"
                            size={'m'}
                            onClick={() => setListModalOpen(true)}
                        />
                    </Grid>
                    {documentType !== 0 && (
                        <Grid
                            className="ofs-logs-update-multiple"
                            size={{
                                md: 6,
                                lg: 2,
                                xl: 2,
                            }}
                        >
                            <SCUIButton
                                className="ofs-logs-update-multiple-button"
                                text={t('billings.updateMultiple')}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                onClick={() => UpdateOFSInformation()}
                            />
                        </Grid>
                    )}
                </Grid>
                {datas ? (
                    <Grid className="ofs-logs-results" container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            className="ofs-logs-results-title"
                            sx={{ margin: '1rem' }}
                            size={{
                                xl: 9,
                                lg: 9,
                                md: 6,
                                xs: 6,
                            }}
                        >
                            <h1 className="headtxt">{t('general.searchResults')}</h1>
                        </Grid>

                        <Grid
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Box className="ofs-logs-data-grid" sx={{ width: '100%' }}>
                                <SCUICustomDataGrid
                                    randomId
                                    rows={datas}
                                    columns={[
                                        { field: 'referenceId', headerName: t('billings.referenceId'), flex: 1 },
                                        { field: 'statusName', headerName: t('billings.status'), flex: 1 },
                                        { field: 'messageText', headerName: t('billings.messageText'), flex: 1 },
                                        {
                                            field: 'createOn',
                                            headerName: '',
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    <span className="ofs-logs-row-created-at">
                                                        {TimeHelper.formatDateHour(params.row.createOn)}
                                                    </span>
                                                );
                                            },
                                        },
                                        {
                                            field: 'show',
                                            headerName: '',
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    <p
                                                        className="cursorPointer ofs-logs-row-update-link"
                                                        onClick={() => UpdateOFSInformation(params.row)}
                                                    >
                                                        {t('general.update')}
                                                    </p>
                                                );
                                            },
                                        },
                                        {
                                            field: 'update',
                                            headerName: '',
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    <p
                                                        className="cursorPointer ofs-logs-row-show-link"
                                                        onClick={() => handleShowOFSLog(params.row)}
                                                    >
                                                        {t('general.show')}
                                                    </p>
                                                );
                                            },
                                        },
                                    ]}
                                    onPageSizeChange={(i: number) => {
                                        setPageSize(i);
                                        setOfsInformationInput({
                                            ...ofsInformationInput,
                                            take: Number(i),
                                        });
                                    }}
                                    pageSize={pageSize}
                                    paginationModeChange
                                    onPageChange={(i: number) => {
                                        setPageNumber(i);
                                        setOfsInformationInput({
                                            ...ofsInformationInput,
                                            skip: Number(i),
                                        });
                                    }}
                                    page={pageNumber}
                                    rowCount={rowCount}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                ) : (
                    <div className="ofs-logs-empty-state">
                        <SCUINoRecordComponent />
                    </div>
                )}
            </Box>
        </SCUIContent>
    );
};
